import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=f486575a&scoped=true"
import script from "./Orcamentos.vue?vue&type=script&lang=js"
export * from "./Orcamentos.vue?vue&type=script&lang=js"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=f486575a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f486575a",
  null
  
)

export default component.exports